
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateProtocol 预览表单项协议
 *  @mixin mixRenderItemTemplateProtocol 渲染预览表单项协议
 */
import { mixPreviewItemTemplateProtocol } from "@/mixins/preview_item/mix_preview_item_template_protocol.js";
import { mixRenderItemTemplateProtocol } from "@/mixins/render_item/mix_render_item_template_protocol.js";


/** mixPreviewItemTemplateProtocol 协议实现
 *  @author 王汝鹏
 *  @version 2019-11-30
 */
export const mixPreviewItemTemplateProtocolRealize = {
  mixins: [ mixPreviewItemTemplateProtocol ],
  computed: {
    /** 协议数据 ::: 
     *  @return {Object} eventMap 事件字典
     *  @return {Object} formMap 表单项字典
     *  @return {Object} formModels 表单填写数据
     *  @return {Object} variableMap 变量设置字典
     */
    preview_item_template_store: { 
      get() {
        let mix_rice_preview_bridge_store = this.mix_rice_preview_bridge_store;
        return {
          get eventMap() { return mix_rice_preview_bridge_store.eventMap; },
          get formMap() { return mix_rice_preview_bridge_store.formMap; },
          get formModels() { return mix_rice_preview_bridge_store.formModels; },
          set formModels(newValue) { mix_rice_preview_bridge_store.formModels = newValue; },
          get variableMap() { return mix_rice_preview_bridge_store.variableMap; }
        }
      }
    },
    /** 协议方法 ::: 
     *  @function preview_item_template_node_action_manager 节点行为管理者
     */
    preview_item_template_node_action_manager: { get() { return this.nodeActionManager; } }
  }
}

export const mixRenderItemTemplateProtocolRealize = {
  mixins: [ mixRenderItemTemplateProtocol ],
  computed: {
    /** 协议数据 ::: 
     *  @return {Object} formModels 表单填写数据
     *  @return {Object} formMap 表单项字典
     */
    render_item_template_store: { 
      get() {
        let mix_rice_preview_bridge_store = this.mix_rice_preview_bridge_store;
        return {
          get formModels() { return mix_rice_preview_bridge_store.formModels; },
          set formModels(newValue) { mix_rice_preview_bridge_store.formModels = newValue; },
          get formMap() { return mix_rice_preview_bridge_store.formMap; }
        }
      }
    }
  }
}   


// WEBPACK FOOTER //
// ./src/mixins/rice_preview_bridge/mix_rice_preview_bridge_protocol_realize.js